import _kebabCase from 'lodash/kebabCase';
import timeNowMixin, { distanceBrokenTimer } from '@src/mixins/timeNow';

const DEFAULT_PREFERENCES = {
  hideParticipantsList: false,
  hideSaveToCalendar: false,
};

export default {
  mixins: [
    timeNowMixin,
  ],
  computed: {
    eventHandle() {
      const { id: eventID, organisation: org, title } = this.event || {};
      if (eventID && title) {
        const handle = _kebabCase(`${typeof org === 'string' && org.length ? org : ''} ${title}`.trim().toLowerCase());
        return `${handle}-${eventID}`;
      } else {
        return null;
      }
    },
    eventHasStarted() {
      const { startDate } = this.event || {};
      return !startDate || this.timeNow > startDate;
    },
    eventHasEnded() {
      const { endDate } = this.event || {};
      return !endDate || this.timeNow > endDate;
    },
    eventIsActive() {
      const { endDate } = this.event || {};
      return this.eventHasStarted && (!endDate || this.timeNow < endDate);
    },
    eventStartsIn() {
      const { startDate } = this.event || {};
      return startDate ? distanceBrokenTimer(startDate, this.timeNow) : null;
    },
    eventEndsIn() {
      const { endDate } = this.event || {};
      return endDate ? distanceBrokenTimer(endDate, this.timeNow) : null;
    },
    eventParticipants() {
      const { participants } = this.event || {};
      if (Array.isArray(participants)) {
        return participants.map(({ user: { id, fullName: name }, createdAt }) => ({ id, name, createdAt }));
      } else {
        return [];
      }
    },
    eventUserParticipant() {
      const { user } = this.$root || {};
      const { participants } = this.event || {};
      return user && user.id && Array.isArray(participants)
        ? participants.find(r => r && r.user && r.user.id === user.id)
        : null;
    },
    eventPreferences() {
      const { preferences } = this.event || {};
      return { ...DEFAULT_PREFERENCES, ...preferences };
    },
    canSyncContacts() {
      const { canSyncContacts } = this.$root || {};
      const { preferences } = this.event || {};
      const { canSyncContacts: canSyncEventContacts } = preferences || {};
      return canSyncContacts === true && canSyncEventContacts !== false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/events.js